import type { DecreaseOrderRow } from '@ui/services/contract/hooks/TradingPortalFacet/useDecreaseOrders/types';
import { Position } from '@ui/services/contract/hooks/TradingReaderFacet/useGetPositionV2/types';

import { EditTpSlType } from '../../types';
import { TpSlEditButton } from '../TpSlEditButton';

export const PositionTpSlEditButton = ({
  position,
  activeDecreaseOrders,
  children,
}: {
  position: Position;
  activeDecreaseOrders?: DecreaseOrderRow[];
  children?: React.ReactNode;
}) => {
  const isPendingPosition = position.isPendingPosition;

  if (isPendingPosition) return null;

  return (
    <TpSlEditButton
      genericTradeParams={position}
      activeDecreaseOrders={activeDecreaseOrders}
      type={EditTpSlType.POSITION}
    >
      {children}
    </TpSlEditButton>
  );
};
